import { Help } from '@mui/icons-material';
import { Typography } from '@mui/material';
import IconButtonWithPopOver from 'Theme/components/IconButtonWithPopOver';
import React from 'react';

interface Props {
  content: React.ReactNode;
  title?: string;
  color?: "inherit" | "primary" | "secondary" | "action" | "disabled" | "error";
  role?: string;
}

function ContextualHelp({ content, title, color, role }: Readonly<Props>) {
  const description = (
    <span style={{ whiteSpace: 'pre-wrap' }}>
      {title && <Typography variant="h6" component="h4" sx={{ mb: 2 }}>{title}</Typography>}
      {content}
    </span>
  );

  return (
    <div style={{ marginLeft: '8px' }} role={role}>
      <IconButtonWithPopOver
        customIcon={<Help fontSize="small" color={color ?? "action"}
          sx={{
            border: "1px solid",
            borderColor: "grey.400",
            borderRadius: "10%",
            p: "9px",
            boxSizing: "content-box",
          }}
        />}
        description={description}
      />
    </div>
  );
}

export default ContextualHelp;
